import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useAuthenticatedFetch } from '../useAuth';

export type MentionableUser = {
  id: string;
  name?: string;
  email?: string;
  kind?: 'user' | 'guest';
  role?: string;
};

interface MentionablesResponse {
  mentionables: MentionableUser[];
}

export function useDiagramMentionables(diagramId?: string): UseQueryResult<MentionableUser[]> {
  const fetcher = useAuthenticatedFetch();
  return useQuery<MentionableUser[]>({
    queryKey: ['diagram', diagramId, 'mentionables'],
    enabled: Boolean(diagramId),
    // Mentionable people change on membership events, not wall-clock time.
    // Without a staleTime this refires on every remount, which at high RTT
    // turns each cache reset into a visible request burst.
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const response = await fetcher(`/api/diagrams/${diagramId}/mentionables`);
      if (!response.ok) {
        throw new Error('Failed to load mentionable users');
      }
      const json = (await response.json()) as MentionablesResponse;
      return json.mentionables ?? [];
    },
  });
}
